/*********************** Custom JS for Boost AI Search & Discovery  ************************/
/*********************** Custom JS for Boost AI Search & Discovery  ************************/
if (window.boostSDAppConfig) {
         window.boostSDAppConfig.integration = Object.assign(
             { labels: 'flair' },
             window.boostSDAppConfig.integration || {}
         );
     } 

const customize = {
  updateProductItem: (componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductItem', {
      name: 'Add Flair on top of the product image',
      enabled: true,
      apply: () => ({
        afterRender(element){
          let productData = element.getParams().props.product;
          let productItem = document.querySelector('.boost-sd__product-item[data-product-id="'+ productData.id +'"]');
          let flairEl = productItem.querySelector('[data-flair-product-badge]');
          if (flairEl) {
            productItem.querySelector('.boost-sd__product-image').append(flairEl);
          }
        }
      }),
    });
  }
}
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateProductItem]);

     /*
const customize = {

  moveHeaderDescription: (componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductList', {
      name: 'Product List component',
      enabled: true,
      apply: () => ({
        afterRender(element) {
          document.dispatchEvent(new CustomEvent('limoniapps:discountninja:collection:productsadded'));
        }
      }),

    });
  }
};

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  customize.moveHeaderDescription,
]);
*/ 